import { Button, Table } from 'antd';
import React from 'react'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { IParcelPerfectConfiguration } from '../../../../app/models/Supplier';

interface IProps {
	onEdit?: (content: IParcelPerfectConfiguration) => void;
	onDelete?: (content: IParcelPerfectConfiguration) => void;
	loading: boolean;
	data?: IParcelPerfectConfiguration[];
}

const SupplierConfigurationTableComponent: React.FC<IProps> = ({onEdit, onDelete, loading, data}) => {

	let columns: any[] = [
		{
			title: 'Type',
			dataIndex: 'type',
			key: 'type',
			width: '15%',
		},
		{
			title: 'Account No',
			dataIndex: 'accountNumber',
			key: 'accountNumber',
			width: '15%',
		},
		{
			title: 'URL',
			dataIndex: 'url',
			key: 'url',
			width: '15%',
		},
		{
			title: 'Username',
			dataIndex: 'credentialsUsername',
			key: 'credentialsUsername',
			width: '15%',
		},
		{
			title: 'Password',
			dataIndex: 'credentialsPassword',
			key: 'credentialsPassword',
			width: '15%',
		}
	];

	if (onEdit && onDelete) {
		columns = [{
			title: 'Edit',
			dataIndex: 'edit',
			key: 'edit',
			width: '5%',
			render: (text: any, record: IParcelPerfectConfiguration) =>
				<Button
					title={'Edit'}
					style={{ border: 0 }}
					icon={<EditOutlined />}
					onClick={() => onEdit(record)}
				/>,
		},
		{
			title: 'Delete',
			dataIndex: 'delete',
			key: 'delete',
			width: '5%',
			render: (text: any, record: IParcelPerfectConfiguration) =>
				<Button
					title={'Delete '}
					style={{ border: 0 }}
					icon={<DeleteOutlined style={{ color: 'red' }} />}
					onClick={() => onDelete(record)}
				/>,
		}, ...columns]
	}

	return (
		<Table
			scroll={{ x: true }}
			loading={loading}
			columns={columns}
			dataSource={data}
		/>
	)
}

export default SupplierConfigurationTableComponent
